import { render, staticRenderFns } from "./KnowledgeBaseEdit.vue?vue&type=template&id=01961100&"
import script from "./KnowledgeBaseEdit.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports